import React from 'react';
import UIComponent from 'ui-components/ui-component';
import './default-style/modal-window.scss';
import Animation from "global-libs/animation/animation";

/**
 * isShow {Boolean} false
 * animType {String} zoom topMove bottomMove leftMove rightMove topExpand bottomExpand leftExpand rightExpand
 */
export default class ModalWindow extends UIComponent{
    get className(){
        let className = super.className;
        return className?className:"default-modal-window";
    }
    set className(className){
        super.className = className;
    }

    get isRegisterEvent() {
        return this.props.isRegisterEvent===true ? true : false;
    }

    get style(){
        return {
            ...super.style,
            position:'fixed',
            overflow:'hidden',
            top:0,
            bottom:0,
            right:0,
            left:0,
            zIndex:1000
        };
    }
    set style(style){
        super.style = style;
    }

    get controlledProps(){
        return [...super.controlledProps, "isShow", "animType"];
    }

    //-------------------------------------------------内部属性及方法-------------------------------------------------
    declareVars(){
        super.declareVars();
        this._animation = null;
    }

    initAnim(){
        if(this._animation){
            Animation.sample(this._animation,0);
        }
        let element = UIComponent.fns.getReactDOM(this.refs.parent);
        let animProps = {};
        switch (this.animType){
            case 'zoom':
                animProps = {
                    scaleX:0,
                    scaleY:0
                };
                break;
            case 'topMove':
                animProps={
                    top:'-100%',
                    bottom:'100%'
                };
                break;
            case 'bottomMove':
                animProps={
                    top:'100%',
                    bottom:'-100%'
                };
                break;
            case 'leftMove':
                animProps={
                    left:'-100%',
                    right:'100%'
                };
                break;
            case 'rightMove':
                animProps={
                    left:'100%',
                    right:'-100%'
                };
                break;
            case 'topExpand':
                animProps={
                    bottom:'100%'
                };
                break;
            case 'bottomExpand':
                animProps={
                    top:'100%'
                };
                break;
            case 'leftExpand':
                animProps={
                    right:'100%'
                };
                break;
            case 'rightExpand':
                animProps={
                    left:'100%'
                };
                break;
        }

        this._animation = Animation.to(element,animProps,
            {
                duration:0.5,
                ease:Animation.ease.easeInOutQuad
            });

        if(this.isShow){
            Animation.sample(this._animation,0);
        }
        else{
            Animation.sample(this._animation,1);
        }
    }

    //-------------------------------------------------对外属性-------------------------------------------------
    get isShow(){
        this.state.isShow = this.state.isShow===true ? true: false;
        return this.state.isShow;
    }
    set isShow(isShow){
        this.setState({isShow:isShow});
    }

    get animType(){
        this.state.animType = this.state.animType || "zoom";
        return this.state.animType;
    }
    set animType(animType){
       this.setState({animType:animType});
    }

    //-------------------------------------------------组件结构-------------------------------------------------
    domDidChange(){
        super.domDidChange();
        if(this._firstInit || this.statesHasChanged("animType")){
            this.initAnim();
        }

        if(this.statesHasChanged("isShow")){
            if(this._animation){
                if(this.isShow){
                    Animation.playBackward(this._animation);
                }else{
                    Animation.playForward(this._animation);
                }
            }
        }
    }
}
